import React from 'react';
import Background from '../components/Background';
import FutureVision from '../components/FutureVision';

const VisionPage = () => {
  return (
    <>
      <Background />
      <div className="page">
        <FutureVision />
      </div>
    </>
  );
};

export default VisionPage;
